export default {
  name: "",
  version: "",
  siteName: "",
  apiBaseURL: "https://api.dbservices.to/v1.7",
  recaptchaKey: "6LfT848pAAAAAAyhNXyA_MlMjiYx4AC3gjdX5qc7",
  sentryDSN: "",
}
